import { useContext } from 'react';
import SidebarContext from 'src/contexts/SidebarContext';

const useSidebar = () => useContext(SidebarContext);

export default useSidebar;
